var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-visits" },
    [
      _c("div", { staticClass: "v-stats" }, [
        _c("div", { staticClass: "v-stat" }, [
          _c("div", { staticClass: "s-label" }, [_vm._v("今日访问（PV）")]),
          _c("div", { staticClass: "s-value" }, [
            _vm._v(_vm._s(_vm.stats.todayPv)),
          ]),
          _c("div", { staticClass: "s-foot" }, [
            _vm._v("昨天 " + _vm._s(_vm.stats.yesterdayPv)),
          ]),
        ]),
        _c("div", { staticClass: "v-stat" }, [
          _c("div", { staticClass: "s-label" }, [_vm._v("今日访客（UV）")]),
          _c("div", { staticClass: "s-value" }, [
            _vm._v(_vm._s(_vm.stats.todayUv)),
          ]),
          _c("div", { staticClass: "s-foot" }, [_vm._v("去重后的访客数")]),
        ]),
        _c("div", { staticClass: "v-stat" }, [
          _c("div", { staticClass: "s-label" }, [_vm._v("今日独立 IP")]),
          _c("div", { staticClass: "s-value" }, [
            _vm._v(_vm._s(_vm.stats.todayIp)),
          ]),
          _c("div", { staticClass: "s-foot" }, [_vm._v("同一网络算一个")]),
        ]),
        _c("div", { staticClass: "v-stat" }, [
          _c("div", { staticClass: "s-label" }, [_vm._v("累计访问")]),
          _c("div", { staticClass: "s-value" }, [
            _vm._v(_vm._s(_vm.stats.totalPv)),
          ]),
          _c("div", { staticClass: "s-foot" }, [
            _vm._v(
              "累计访客 " +
                _vm._s(_vm.stats.totalUv) +
                " · IP " +
                _vm._s(_vm.stats.totalIp)
            ),
          ]),
        ]),
        _c("div", { staticClass: "v-stat trend" }, [
          _c("div", { staticClass: "s-label" }, [_vm._v("近 7 日")]),
          _c(
            "div",
            { staticClass: "v-bars" },
            _vm._l(_vm.stats.trend, function (d) {
              return _c(
                "div",
                {
                  key: d.date,
                  staticClass: "bar",
                  attrs: {
                    title: d.date + "：" + d.pv + " 次 / " + d.uv + " 人",
                  },
                },
                [
                  _c("span", {
                    staticClass: "b-fill",
                    style: { height: _vm.barHeight(d.pv) },
                  }),
                  _c("span", { staticClass: "b-label" }, [
                    _vm._v(_vm._s(d.date.slice(5))),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "a-card" }, [
        _c("div", { staticClass: "a-toolbar" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query.keyword,
                expression: "query.keyword",
              },
            ],
            staticClass: "a-input",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "账号 / 昵称 / IP / 路径" },
            domProps: { value: _vm.query.keyword },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.query, "keyword", $event.target.value)
              },
            },
          }),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.source,
                  expression: "query.source",
                },
              ],
              staticClass: "a-select",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.query,
                      "source",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.search,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "all" } }, [_vm._v("全部来源")]),
              _c("option", { attrs: { value: "page" } }, [_vm._v("页面浏览")]),
              _c("option", { attrs: { value: "entry" } }, [_vm._v("打开站点")]),
              _c("option", { attrs: { value: "admin" } }, [_vm._v("后台登录")]),
              _c("option", { attrs: { value: "api" } }, [_vm._v("接口访问")]),
            ]
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.device,
                  expression: "query.device",
                },
              ],
              staticClass: "a-select",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.query,
                      "device",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.search,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "all" } }, [_vm._v("全部设备")]),
              _c("option", { attrs: { value: "pc" } }, [_vm._v("电脑")]),
              _c("option", { attrs: { value: "mobile" } }, [_vm._v("手机")]),
              _c("option", { attrs: { value: "tablet" } }, [_vm._v("平板")]),
            ]
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.account,
                  expression: "query.account",
                },
              ],
              staticClass: "a-select",
              staticStyle: { "max-width": "150px" },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.query,
                      "account",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.search,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "all" } }, [_vm._v("全部账号")]),
              _vm._l(_vm.facets.accounts, function (a) {
                return _c("option", { key: a, domProps: { value: a } }, [
                  _vm._v(_vm._s(a)),
                ])
              }),
            ],
            2
          ),
          _c("span", { staticClass: "date-range" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.startDate,
                  expression: "query.startDate",
                },
              ],
              staticClass: "a-input",
              attrs: { type: "date" },
              domProps: { value: _vm.query.startDate },
              on: {
                change: _vm.search,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.query, "startDate", $event.target.value)
                },
              },
            }),
            _c("em", [_vm._v("~")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query.endDate,
                  expression: "query.endDate",
                },
              ],
              staticClass: "a-input",
              attrs: { type: "date" },
              domProps: { value: _vm.query.endDate },
              on: {
                change: _vm.search,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.query, "endDate", $event.target.value)
                },
              },
            }),
          ]),
          _c(
            "button",
            { staticClass: "a-btn primary", on: { click: _vm.search } },
            [_vm._v("查询")]
          ),
          _c("button", { staticClass: "a-btn", on: { click: _vm.reset } }, [
            _vm._v("重置"),
          ]),
          _c("span", { staticClass: "grow" }),
          _c(
            "button",
            {
              staticClass: "a-btn",
              attrs: { disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.load(true)
                },
              },
            },
            [_vm._v("刷新")]
          ),
          _c(
            "button",
            {
              staticClass: "a-btn",
              attrs: { disabled: _vm.exporting },
              on: { click: _vm.exportCsv },
            },
            [_vm._v(" " + _vm._s(_vm.exporting ? "导出中…" : "导出 CSV") + " ")]
          ),
          _c(
            "button",
            {
              staticClass: "a-btn danger",
              on: {
                click: function ($event) {
                  _vm.clearOpen = true
                },
              },
            },
            [_vm._v("清理记录")]
          ),
        ]),
        _vm.loading
          ? _c("div", { staticClass: "a-empty" }, [_vm._v("正在加载…")])
          : !_vm.items.length
          ? _c("div", { staticClass: "a-empty" }, [
              _vm._v(
                " 还没有访问记录。用户打开前台页面后就会自动记录（IP、账号、时间、访问页面）。 "
              ),
            ])
          : _c("table", { staticClass: "a-table" }, [
              _vm._m(0),
              _c(
                "tbody",
                _vm._l(_vm.items, function (it) {
                  return _c("tr", { key: it.id }, [
                    _c("td", { staticClass: "muted small" }, [
                      _vm._v(_vm._s(it.createTime)),
                    ]),
                    _c("td", [
                      _c(
                        "span",
                        { staticClass: "v-src", class: "src-" + it.source },
                        [_vm._v(_vm._s(_vm.srcLabel(it.source)))]
                      ),
                    ]),
                    _c("td", [
                      it.account
                        ? _c("div", { staticClass: "who" }, [
                            _c("span", { staticClass: "w-name" }, [
                              _vm._v(_vm._s(it.nickname || it.account)),
                            ]),
                            it.nickname && it.nickname !== it.account
                              ? _c("span", { staticClass: "w-acc" }, [
                                  _vm._v(_vm._s(it.account)),
                                ])
                              : _vm._e(),
                          ])
                        : _c("span", { staticClass: "muted" }, [
                            _vm._v("游客"),
                          ]),
                    ]),
                    _c("td", [
                      _c("div", { staticClass: "ip-cell" }, [
                        _c("code", [_vm._v(_vm._s(it.ip || "—"))]),
                        it.region
                          ? _c("span", { staticClass: "region" }, [
                              _vm._v(_vm._s(it.region)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c("td", [
                      _c("code", { staticClass: "path" }, [
                        _vm._v(_vm._s(it.path || "—")),
                      ]),
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "muted ellipsis",
                        attrs: { title: it.title },
                      },
                      [_vm._v(_vm._s(it.title || "—"))]
                    ),
                    _c(
                      "td",
                      { staticClass: "muted small" },
                      [
                        _vm._v(" " + _vm._s(_vm.deviceLabel(it.device)) + " "),
                        it.browser
                          ? [_vm._v(" · " + _vm._s(it.browser))]
                          : _vm._e(),
                        it.os ? [_vm._v(" · " + _vm._s(it.os))] : _vm._e(),
                      ],
                      2
                    ),
                    _c("td", { staticClass: "muted small" }, [
                      _vm._v(_vm._s(_vm.stayLabel(it.stayMs))),
                    ]),
                    _c("td", { staticClass: "col-ops" }, [
                      _c(
                        "button",
                        {
                          staticClass: "a-btn mini",
                          on: {
                            click: function ($event) {
                              return _vm.detail(it)
                            },
                          },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "a-btn mini danger",
                          on: {
                            click: function ($event) {
                              return _vm.remove(it)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
        _vm.total > _vm.query.size
          ? _c("div", { staticClass: "a-pager" }, [
              _c("span", [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.total) +
                    " 条 · 第 " +
                    _vm._s(_vm.query.page) +
                    "/" +
                    _vm._s(_vm.pages) +
                    " 页"
                ),
              ]),
              _c(
                "button",
                {
                  staticClass: "a-btn mini",
                  attrs: { disabled: _vm.query.page <= 1 },
                  on: {
                    click: function ($event) {
                      return _vm.go(_vm.query.page - 1)
                    },
                  },
                },
                [_vm._v("上一页")]
              ),
              _c(
                "button",
                {
                  staticClass: "a-btn mini",
                  attrs: { disabled: _vm.query.page >= _vm.pages },
                  on: {
                    click: function ($event) {
                      return _vm.go(_vm.query.page + 1)
                    },
                  },
                },
                [_vm._v("下一页")]
              ),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "v-ranks" }, [
        _c("div", { staticClass: "a-card rank" }, [
          _c("div", { staticClass: "rank-head" }, [_vm._v("热门页面 Top 10")]),
          !_vm.stats.topPages.length
            ? _c("div", { staticClass: "rank-empty" }, [_vm._v("暂无数据")])
            : _c(
                "ul",
                _vm._l(_vm.stats.topPages, function (p, i) {
                  return _c("li", { key: p.name }, [
                    _c(
                      "span",
                      { staticClass: "r-no", class: { top3: i < 3 } },
                      [_vm._v(_vm._s(i + 1))]
                    ),
                    _c("code", { staticClass: "r-name" }, [
                      _vm._v(_vm._s(p.name)),
                    ]),
                    _c("span", { staticClass: "r-count" }, [
                      _vm._v(_vm._s(p.count)),
                    ]),
                  ])
                }),
                0
              ),
        ]),
        _c("div", { staticClass: "a-card rank" }, [
          _c("div", { staticClass: "rank-head" }, [_vm._v("活跃账号 Top 10")]),
          !_vm.stats.topAccounts.length
            ? _c("div", { staticClass: "rank-empty" }, [
                _vm._v("暂无数据（未登录访问记为「游客」）"),
              ])
            : _c(
                "ul",
                _vm._l(_vm.stats.topAccounts, function (p, i) {
                  return _c("li", { key: p.name }, [
                    _c(
                      "span",
                      { staticClass: "r-no", class: { top3: i < 3 } },
                      [_vm._v(_vm._s(i + 1))]
                    ),
                    _c("span", { staticClass: "r-name acc" }, [
                      _vm._v(_vm._s(p.name)),
                    ]),
                    _c("span", { staticClass: "r-count" }, [
                      _vm._v(_vm._s(p.count)),
                    ]),
                  ])
                }),
                0
              ),
        ]),
      ]),
      _vm.current
        ? _c(
            "div",
            {
              staticClass: "v-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.current = null
                },
              },
            },
            [
              _c("div", { staticClass: "v-modal" }, [
                _c("div", { staticClass: "m-head" }, [
                  _c("h3", [_vm._v("访问详情 #" + _vm._s(_vm.current.id))]),
                  _c(
                    "span",
                    {
                      staticClass: "m-close",
                      on: {
                        click: function ($event) {
                          _vm.current = null
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "m-body" },
                  _vm._l(_vm.detailRows, function (row) {
                    return _c("div", { key: row.k, staticClass: "m-row" }, [
                      _c("span", { staticClass: "m-k" }, [
                        _vm._v(_vm._s(row.k)),
                      ]),
                      _c("span", { staticClass: "m-v" }, [
                        _vm._v(_vm._s(row.v || "—")),
                      ]),
                    ])
                  }),
                  0
                ),
                _c("div", { staticClass: "m-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "a-btn",
                      on: {
                        click: function ($event) {
                          _vm.current = null
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.clearOpen
        ? _c(
            "div",
            {
              staticClass: "v-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.clearOpen = false
                },
              },
            },
            [
              _c("div", { staticClass: "v-modal narrow" }, [
                _c("div", { staticClass: "m-head" }, [
                  _c("h3", [_vm._v("清理访问记录")]),
                  _c(
                    "span",
                    {
                      staticClass: "m-close",
                      on: {
                        click: function ($event) {
                          _vm.clearOpen = false
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _c("div", { staticClass: "m-body" }, [
                  _c("div", { staticClass: "a-form-row" }, [
                    _c("label", { staticClass: "f-label" }, [
                      _vm._v("清理方式"),
                    ]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.clearForm.mode,
                            expression: "clearForm.mode",
                          },
                        ],
                        staticClass: "a-select",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.clearForm,
                              "mode",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "days" } }, [
                          _vm._v("只保留最近 N 天"),
                        ]),
                        _c("option", { attrs: { value: "before" } }, [
                          _vm._v("清空指定日期之前"),
                        ]),
                        _c("option", { attrs: { value: "all" } }, [
                          _vm._v("全部清空"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm.clearForm.mode === "days"
                    ? _c("div", { staticClass: "a-form-row" }, [
                        _c("label", { staticClass: "f-label" }, [
                          _vm._v("保留天数"),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clearForm.days,
                              expression: "clearForm.days",
                            },
                          ],
                          staticClass: "a-input",
                          attrs: { type: "number", min: "1", max: "3650" },
                          domProps: { value: _vm.clearForm.days },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.clearForm,
                                "days",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm.clearForm.mode === "before"
                    ? _c("div", { staticClass: "a-form-row" }, [
                        _vm._m(1),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clearForm.date,
                              expression: "clearForm.date",
                            },
                          ],
                          staticClass: "a-input",
                          attrs: { type: "date" },
                          domProps: { value: _vm.clearForm.date },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.clearForm,
                                "date",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "danger-tip" }, [
                    _vm._v("删除后不可恢复，请谨慎操作。"),
                  ]),
                ]),
                _c("div", { staticClass: "m-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "a-btn",
                      on: {
                        click: function ($event) {
                          _vm.clearOpen = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "a-btn danger",
                      attrs: { disabled: _vm.clearing },
                      on: { click: _vm.doClear },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.clearing ? "清理中…" : "确认清理") +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.toast
          ? _c("div", { staticClass: "a-toast", class: _vm.toast.type }, [
              _vm._v(_vm._s(_vm.toast.text)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "148px" } }, [_vm._v("时间")]),
        _c("th", { staticStyle: { width: "84px" } }, [_vm._v("来源")]),
        _c("th", { staticStyle: { width: "132px" } }, [_vm._v("账号")]),
        _c("th", { staticStyle: { width: "138px" } }, [_vm._v("IP / 归属")]),
        _c("th", { staticStyle: { width: "190px" } }, [_vm._v("访问页面")]),
        _c("th", [_vm._v("标题")]),
        _c("th", { staticStyle: { width: "150px" } }, [_vm._v("设备")]),
        _c("th", { staticStyle: { width: "74px" } }, [_vm._v("停留")]),
        _c("th", { staticStyle: { width: "90px" } }, [_vm._v("操作")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("清空这个日期之前的记录"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("（不含当天）")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }